import React, {useContext} from "react";
import { Menu, Dropdown, Avatar } from "antd";
import {connect, useSelector} from 'react-redux'
import { 
  EditOutlined, 
  SettingOutlined, 
  ShopOutlined, 
  QuestionCircleOutlined, 
  LogoutOutlined 
} from '@ant-design/icons';
import Icon from 'components/util-components/Icon';
import { signOut } from 'redux/actions/Auth';
/*import { appContext } from "services/Context";*/
import { useHistory } from "react-router-dom";
import { API_BASE_URL } from "configs/AppConfig";

const menuItem = [
	{
		title: "Edit Profile",
		icon: EditOutlined ,
		path: "/app/pages/setting/edit-profile"
    },
    
    {
		title: "Account Setting",
		icon: SettingOutlined,
		path: "/app/pages/trading-accounts/accounts"
    },
    {
		title: "Billing",
		icon: ShopOutlined ,
		path: "/app/pages/billing/wallet"
	},
    {
		title: "Help Center",
		icon: QuestionCircleOutlined,
		path: "/"
	}
]

export const NavProfile = ({signOut}) => {
    const user = useSelector((state) => state.user.user);

    let history = useHistory();
  const profileImg = "/img/avatars/thumb-1.jpg";
  const profileMenu = (
    <div className="nav-profile nav-dropdown">
      <div className="nav-profile-header">
        <div className="d-flex">
          <Avatar size={45} src={user?.avatar?.url ? API_BASE_URL + user?.avatar?.url : '/default/avatar.svg'} />
          <div className="pl-3">
            <h4 className="mb-0">{user?.first_name + ' ' + user?.last_name}</h4>
            <span className="text-muted">{String(user?.role).charAt(0).toUpperCase() + String(user?.role).slice(1)}</span>
          </div>
        </div>
      </div>
      <div className="nav-profile-body">
        <Menu>
          {menuItem.map((el, i) => {
            return (
              <Menu.Item key={i}>
                <a href={el.path}>
                  <Icon className="mr-3" type={el.icon} />
                  <span className="font-weight-normal">{el.title}</span>
                </a>
              </Menu.Item>
            );
          })}
          <Menu.Item key={menuItem.length + 1} onClick={e => signOut()}>
            <span>
              <LogoutOutlined className="mr-3"/>
              <span className="font-weight-normal">Sign Out</span>
            </span>
          </Menu.Item>
        </Menu>
      </div>
    </div>
  );
  return (
    <Dropdown placement="bottomRight" overlay={profileMenu} trigger={["click"]}>
      <Menu className="d-flex align-item-center" mode="horizontal">
        <Menu.Item>
          <Avatar src={user?.avatar?.url ? API_BASE_URL + user?.avatar?.url : '/default/avatar.svg'} />
        </Menu.Item>
      </Menu>
    </Dropdown>
  );
}

export default connect(null, {signOut})(NavProfile)
